import { View } from '@zinc/ui';
import FieldSelect from 'bz-core-controls/controls/form/field/field-select';
import type { Item } from 'bz-core-controls/controls/form/field/field-select/iprops';
import React, { useCallback } from 'react';

export interface IProps {
  onCategoryChange: (value: string) => void;
  category?: string;
  displayMember: string;
  valueMember: string;
  selectorLabel: string;
  items: Item[];
}

const ListHeader: React.FC<IProps> = React.memo(
  ({ selectorLabel, items, displayMember, valueMember, category, onCategoryChange }) => {
    const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
      onCategoryChange(e.target.value);
    }, []);

    return (
      <View className="px-2 pb-2">
        <FieldSelect
          label={selectorLabel}
          items={items}
          displayMember={displayMember}
          valueMember={valueMember}
          value={category}
          onChange={onChange}
        />
      </View>
    );
  }
);

ListHeader.displayName = 'ListHeader';

export default ListHeader;
